<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    append-to-body
    width="600px"
    :before-close="close"
    custom-class="rich-text-dialog"
  >
    <div class="rich-text-container">
      <EditableBox
        ref="editableBox"
        :mode="mode"
        :includeBtns="['confirm', 'edit']"
        @onEdit="handelEdit"
        @onAdd="handleAdd"
        @onDelete="handleDelete"
        @onConfirm="hanldeConfirm"
      >
        <template slot-scope="scope">
          <template v-if="scope.isEdit">
            <editor-input :image-style="imageStyle" v-model="inputValue" @onBlur="hanldeConfirm"> </editor-input>
          </template>
          <render-html v-else-if="isEditorValue" :editor-data="richTextData.data"></render-html>
          <template v-else>
            {{ richTextData }}
          </template>
        </template>
      </EditableBox>
    </div>
  </el-dialog>
</template>

<script>
import EditableBox from "../EditableBox/index.jsx";
import EditorInput from "../EditorInput.vue";
import RenderHtml from "@/components/SimpleEditor/RenderHtml.jsx";
export default {
  name: "RichTextDialog",
  components: {
    EditableBox,
    EditorInput,
    RenderHtml
  },
  props: {
    mode: String,
    editorData: {
      type: [String, Object],
      default: () => ({})
    }
  },
  data() {
    return {
      id: "",
      visible: false,
      richTextData: "富文本内容",
      imageStyle: {},
      inputValue: ""
    };
  },
  computed: {
    isEditorValue() {
      return (
        typeof this.richTextData !== "string" && this.richTextData.type && this.richTextData.type === "simpleEditor"
      );
    }
  },

  mounted() {},

  methods: {
    open(id, data) {
      this.visible = true;
      this.id = id;
      this.richTextData = data || "富文本内容";
      this.inputValue = data || "富文本内容";
    },
    close() {
      this.visible = false;
    },
    handelEdit() {},
    handleAdd() {
      this.$emit("onAdd");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    hanldeConfirm() {
      const editorData = JSON.parse(JSON.stringify(this.editorData));
      const data = editorData.data;
      // 将数据更新到button
      data.forEach(item => {
        item.children.forEach(child => {
          if (child.type === "button" && child.id === this.id) {
            child.data = this.inputValue;
          }
        });
      });
      this.richTextData = this.inputValue;
      // console.log(editorData);
      this.$emit("onChange", editorData);
    }
  }
};
</script>

<style lang="less" scoped>
.rich-text-dialog {
  .rich-text-container {
    padding: 15px 0;
  }
}
</style>
